module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-barrel-shadow-5.63dc9829.png";